export default __webpack_public_path__ + "static/media/gallery-one.ddf753c4.jpg";